var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCcCaptions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2 4H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 00-1.311 1.311C2 6.28 2 7.12 2 8.8v6.4c0 1.68 0 2.52.327 3.162a3 3 0 001.311 1.311C4.28 20 5.12 20 6.8 20h10.4c1.68 0 2.52 0 3.162-.327a3 3 0 001.311-1.311C22 17.72 22 16.88 22 15.2V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 00-1.311-1.311C19.72 4 18.88 4 17.2 4z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.672 10c.544 0 1.034.254 1.371.667a.869.869 0 001.298.079c.38-.367.41-1 .073-1.413C10.744 8.517 9.764 8 8.676 8 6.646 8 5 9.792 5 12s1.647 4 3.676 4c1.088 0 2.068-.517 2.738-1.333a1.064 1.064 0 00-.073-1.413c-.379-.37-.957-.333-1.298.08a1.765 1.765 0 01-1.37.666c-1.015 0-1.839-.896-1.839-2s.824-2 1.838-2zm5.515 2c0-1.104.823-2 1.838-2 .543 0 1.034.254 1.37.667a.869.869 0 001.299.079c.379-.367.41-1 .072-1.413C18.096 8.517 17.116 8 16.03 8c-2.03 0-3.677 1.792-3.677 4S14 16 16.03 16c1.087 0 2.067-.517 2.737-1.333a1.064 1.064 0 00-.072-1.413c-.38-.37-.958-.333-1.299.08a1.765 1.765 0 01-1.37.666c-1.015 0-1.838-.896-1.838-2z",
    fill: "#fff"
  })));
}
export default SvgCcCaptions;